// Presentation rollout only. JWT authorization and the backend capability
// remain authoritative. DEV keeps its currently deployed administration UI.
export function supportsClientCreation(hostname = window.location.hostname): boolean {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  return host === 'app.agrisafe.fr' || host === 'soverdi.agrisafe.fr';
}
